import { Injectable, Inject, forwardRef } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { ImgCropService } from './img-crop.service';
var ImgResizeExactService = /** @class */ (function () {
    function ImgResizeExactService(ng2ImgMaxService, imgCropService) {
        this.ng2ImgMaxService = ng2ImgMaxService;
        this.imgCropService = imgCropService;
    }
    ImgResizeExactService.prototype.resizeExactFill = function (file, toWidth, toHeight, fillColor) {
        var _this = this;
        var resizedImageSubject = new Subject();
        if (file.type !== "image/jpeg" && file.type !== "image/png") {
            setTimeout(function () {
                resizedImageSubject.error({ resizedFile: file, reason: "File provided is neither of type jpg nor of type png.", error: "INVALID_EXTENSION" });
            }, 0);
            return resizedImageSubject.asObservable();
        }
        var img = new Image();
        img.onload = function () {
            _this.ng2ImgMaxService.getEXIFOrientedImage(img).then(function (orientedImg) {
                window.URL.revokeObjectURL(img.src);
                var imgRatio = orientedImg.width / orientedImg.height;
                var resizedRatio = toWidth / toHeight;
                /* ratio > 1 means width > height */
                /* setting one parameter of ng2ImgMaxService very high will ensure that the resizing will fit the other provided parameter */
                var resizeHeight = 100000;
                var resizeWidth = 100000;
                if (imgRatio > resizedRatio) {
                    /* the original height is smaller than the resized height as in ratio, therefore we have to resize to width, then fill to the height */
                    resizeWidth = toWidth;
                }
                else if (imgRatio <= resizedRatio) {
                    /* the original height is bigger than the resized height as in ratio, therefore we can resize to height, then fill to the width */
                    resizeHeight = toHeight;
                }
                _this.ng2ImgMaxService.resize([file], resizeWidth, resizeHeight).subscribe(function (resizeResult) {
                    /* To fill the image based on the center, we calculate where the img needs to be positioned to be centered*/
                    var startX = 0;
                    var startY = 0;
                    /* one side is already resized exactly to the desired size, now fill the other side */
                    if (resizeWidth === 100000) {
                        /* resized to height -> as we fill to the width, we have to set startX */
                        var newImgWidth = orientedImg.width / (orientedImg.height / toHeight);
                        startX = (newImgWidth - toWidth) / 2;
                    }
                    else if (resizeHeight === 100000) {
                        /* resized to width -> as we fill to the height, we have to set startY */
                        var newImgHeight = orientedImg.height / (orientedImg.width / toWidth);
                        startY = (newImgHeight - toHeight) / 2;
                    }
                    var img = new Image();
                    var cvs = document.createElement('canvas');
                    var ctx = cvs.getContext('2d');
                    img.onload = function () {
                        cvs.width = toWidth;
                        cvs.height = toHeight;
                        if (fillColor) {
                            ctx.fillStyle = fillColor;
                            ctx.fillRect(0, 0, toWidth, toHeight);
                        }
                        ctx.drawImage(img, startX, startY, toWidth, toHeight, 0, 0, toWidth, toHeight);
                        var imageData = ctx.getImageData(0, 0, toWidth, toHeight);
                        var useAlpha = true;
                        if (file.type === "image/jpeg" || (file.type === "image/png" && !_this.isImgUsingAlpha(imageData))) {
                            //image without alpha
                            useAlpha = false;
                            ctx = cvs.getContext('2d', { 'alpha': false });
                            if (fillColor) {
                                ctx.fillStyle = fillColor;
                                ctx.fillRect(0, 0, toWidth, toHeight);
                            }
                            ctx.drawImage(img, startX, startY, toWidth, toHeight, 0, 0, toWidth, toHeight);
                        }
                        cvs.toBlob(function (blob) {
                            window.URL.revokeObjectURL(img.src);
                            var newFile = _this.generateResultFile(blob, file.name, file.type, new Date().getTime());
                            // END OF CROPPING
                            resizedImageSubject.next(newFile);
                        }, useAlpha ? "image/png" : "image/jpeg");
                    };
                    img.src = window.URL.createObjectURL(resizeResult);
                }, function (error) {
                    //something went wrong 
                    resizedImageSubject.error(error);
                });
            });
        };
        img.src = window.URL.createObjectURL(file);
        return resizedImageSubject.asObservable();
    };
    ImgResizeExactService.prototype.resizeExactCrop = function (file, toWidth, toHeight) {
        var _this = this;
        var resizedImageSubject = new Subject();
        if (file.type !== "image/jpeg" && file.type !== "image/png") {
            setTimeout(function () {
                resizedImageSubject.error({ resizedFile: file, reason: "File provided is neither of type jpg nor of type png.", error: "INVALID_EXTENSION" });
            }, 0);
            return resizedImageSubject.asObservable();
        }
        var img = new Image();
        img.onload = function () {
            _this.ng2ImgMaxService.getEXIFOrientedImage(img).then(function (orientedImg) {
                window.URL.revokeObjectURL(img.src);
                var imgRatio = orientedImg.width / orientedImg.height;
                var resizedRatio = toWidth / toHeight;
                /* ratio > 1 means width > height */
                /* setting one parameter of ng2ImgMaxService very high will ensure that the resizing will fit the other provided parameter */
                var resizeHeight = 100000;
                var resizeWidth = 100000;
                /* To crop the image based on the center, so we will keep the most important part of the image, we calculate to crop from where to where */
                var startX = 0;
                var startY = 0;
                if (imgRatio > resizedRatio) {
                    /* the original height is smaller than the resized height as in ratio, therefore we have to resize to height, then crop to the width */
                    resizeHeight = toHeight;
                }
                else if (imgRatio <= resizedRatio) {
                    /* the original height is bigger than the resized height as in ratio, therefore we can resize to width, then crop to the height */
                    resizeWidth = toWidth;
                }
                _this.ng2ImgMaxService.resize([file], resizeWidth, resizeHeight).subscribe(function (resizeResult) {
                    /* one side is already resized exactly to the desired size, now crop the other side */
                    if (resizeWidth === 100000) {
                        /* resized to height -> as we crop to the width, we have to set startX */
                        var newImgWidth = orientedImg.width / (orientedImg.height / toHeight);
                        startX = (newImgWidth - toWidth) / 2;
                    }
                    else if (resizeHeight === 100000) {
                        /* resized to width -> as we crop to the height, we have to set startY */
                        var newImgHeight = orientedImg.height / (orientedImg.width / toWidth);
                        startY = (newImgHeight - toHeight) / 2;
                    }
                    _this.imgCropService.cropImage(resizeResult, toWidth, toHeight, startX, startY).subscribe(function (cropResult) {
                        //all good, result is a file
                        resizedImageSubject.next(cropResult);
                    }, function (error) {
                        //something went wrong 
                        resizedImageSubject.error(error);
                    });
                }, function (error) {
                    //something went wrong 
                    resizedImageSubject.error(error);
                });
            });
        };
        img.src = window.URL.createObjectURL(file);
        return resizedImageSubject.asObservable();
    };
    ImgResizeExactService.prototype.isImgUsingAlpha = function (imageData) {
        for (var i = 0; i < imageData.data.length; i += 4) {
            if (imageData.data[i + 3] !== 255) {
                return true;
            }
        }
        return false;
    };
    ImgResizeExactService.prototype.generateResultFile = function (blob, name, type, lastModified) {
        var resultFile = new Blob([blob], { type: type });
        return this.blobToFile(resultFile, name, lastModified);
    };
    ImgResizeExactService.prototype.blobToFile = function (blob, name, lastModified) {
        var file = blob;
        file.name = name;
        file.lastModified = lastModified;
        //Cast to a File() type
        return file;
    };
    ImgResizeExactService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ImgResizeExactService.ctorParameters = function () { return [
        { type: Ng2ImgMaxService, decorators: [{ type: Inject, args: [forwardRef(function () { return Ng2ImgMaxService; }),] }] },
        { type: ImgCropService, decorators: [{ type: Inject, args: [forwardRef(function () { return ImgCropService; }),] }] }
    ]; };
    return ImgResizeExactService;
}());
export { ImgResizeExactService };
//# sourceMappingURL=img-resize-exact.service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-img-tools/dist/src/img-resize-exact.service.js
// module id = ./node_modules/ng2-img-tools/dist/src/img-resize-exact.service.js
// module chunks = 0